import ChangeCircleRoundedIcon from "@mui/icons-material/ChangeCircleRounded";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import { Badge, IconButton, Menu, styled } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomUserIcon from "../../../../app/assets/custom-icons/CustomUserIcon";
import { ROLE } from "../../../../utils/constants/profiles";
import ListsAdminStudios from "./itemsList/ListsAdminStudios";
import ListsNotification from "./itemsList/ListsNotification";
import ListsSettings from "./itemsList/ListsSettings";
import { useGetProfileUserQuery } from "../../../../features/api/user/modificaProfiloApi";

const CustomToolbar = ({ routes }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const studioName = useSelector((state) => state.app.studioName);
  const role = useSelector((state) => state.app.role);
  const userEmail = useSelector((state) => state.app.userEmail);
  const primaryColor = useSelector((state) => state.app.primaryColor);
  const notifications = useSelector((state) => state.app.notifications);
  const appConfig = useSelector((state) => state.app.appConfig);
  const reduxProfile = useSelector((state) => state.app.profile);
  const adminStudios = useSelector((state) => state.app.adminStudios);
  const requireUser = appConfig?.modules?.profile;
  const { data: dataProfile } = useGetProfileUserQuery(undefined, {
    skip: role !== ROLE.USER,
  });

  const isProfileRoute =
    location.pathname.includes(t("profile")) ||
    location.pathname.endsWith(t("profile"));

  const isProfileIncomplete =
    role === ROLE.USER &&
    isProfileRoute &&
    !dataProfile?.Data?.isCompany &&
    Object.keys(requireUser)
      .map((key) => requireUser[key] && !reduxProfile[key])
      .some((value) => value);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElNotifiche, setAnchorElNotifiche] = useState(null);
  const [anchorElSelectedStudio, setAnchorElSelectedStudio] = useState(null);

  useEffect(() => {
    const isAnyMenuOpen =
      Boolean(anchorEl) ||
      Boolean(anchorElNotifiche) ||
      Boolean(anchorElSelectedStudio);

    if (isAnyMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [anchorEl, anchorElNotifiche, anchorElSelectedStudio]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      border: `2px solid white`,
      padding: "5px",
    },
  }));

  return (
    <div style={{ position: "relative" }}>
      <Toolbar className="bg-white shadow-none flex justify-end items-center h-[72px]">
        <div className="flex items-center">
          <IconButton
            onClick={() => navigate("assistenza")}
            disabled={isProfileIncomplete}
            style={
              isProfileIncomplete ? { pointerEvents: "none", opacity: 0.5 } : {}
            }
          >
            <HelpRoundedIcon style={{ color: `${primaryColor}` }} />
          </IconButton>

          <StyledBadge
            badgeContent={
              notifications.filter((notifica) => notifica?.read !== true).length
            }
            invisible={notifications.length > 0 ? false : true}
            color="error"
            className="bottom-2 left-8 "
          />
          <IconButton
            onClick={(e) => setAnchorElNotifiche(e.currentTarget)}
            disabled={isProfileIncomplete}
            style={
              isProfileIncomplete ? { pointerEvents: "none", opacity: 0.5 } : {}
            }
          >
            <NotificationsRoundedIcon
              style={{
                color: `${primaryColor}`,
              }}
            />
          </IconButton>
          <Menu
            anchorEl={anchorElNotifiche}
            open={Boolean(anchorElNotifiche)}
            onClose={() => setAnchorElNotifiche(null)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <ListsNotification
              lists={notifications}
              setAnchorElNotifiche={setAnchorElNotifiche}
            />
          </Menu>

          {adminStudios?.length > 1 &&
            role !== ROLE.USER &&
            role !== ROLE.ADMIN && (
              <IconButton
                onClick={(e) => setAnchorElSelectedStudio(e.currentTarget)}
              >
                <ChangeCircleRoundedIcon style={{ color: `${primaryColor}` }} />
              </IconButton>
            )}
          <Menu
            anchorEl={anchorElSelectedStudio}
            open={Boolean(anchorElSelectedStudio)}
            onClose={() => setAnchorElSelectedStudio(null)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <ListsAdminStudios lists={adminStudios} />
          </Menu>
        </div>

        <div className="border-r border-white h-6 mx-4"></div>
        <div className="flex flex-row items-center space-x-4">
          <div className="text-black font-bold">
            {role === ROLE.USER
              ? userEmail
              : role === ROLE.ADMIN
              ? userEmail
              : studioName}
          </div>
          <div className="">
            <button
              style={{
                zIndex: 11,
              }}
              onClick={handleMenuOpen}
              className=" ring-inset border-none bg-white cursor-pointer text-white"
            >
              <CustomUserIcon className="w-11 h-11" />
            </button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <ListsSettings
                routes={routes}
                isProfileIncomplete={isProfileIncomplete}
              />
            </Menu>
          </div>
        </div>
      </Toolbar>
      <div style={{ position: "relative" }}>
        {isProfileIncomplete && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255,255,255,0.5)",
              zIndex: 10,
              pointerEvents: "all",
              cursor: "not-allowed",
            }}
          />
        )}
      </div>
    </div>
  );
};

export default CustomToolbar;
